import { queryOptions } from '@tanstack/react-query'

import { api, data } from '../client'
import { qk } from '../query-keys'

export const languagesQuery = queryOptions({
  queryKey: qk.languages,
  queryFn: async ({ signal }) => (await data(api.GET('/languages', { signal }))).items,
  staleTime: Infinity,
})

export const clientConfigQuery = queryOptions({
  queryKey: qk.clientConfig,
  queryFn: async ({ signal }) => data(api.GET('/config', { signal })),
  staleTime: Infinity,
})

/** One company glossary per pair; with an automatic source, every glossary for the target. */
export function companyGlossariesQuery(sourceLang: string | null, targetLang: string) {
  return queryOptions({
    queryKey: qk.companyGlossaries(sourceLang, targetLang),
    queryFn: async ({ signal }) =>
      (
        await data(
          api.GET('/company-glossaries', {
            params: { query: { targetLang, ...(sourceLang ? { sourceLang } : {}) } },
            signal,
          }),
        )
      ).items,
    staleTime: 5 * 60_000,
    enabled: targetLang !== '',
  })
}
